import { render } from "./ReservationForm.vue?vue&type=template&id=6b661fc4&scoped=true"
import script from "./ReservationForm.vue?vue&type=script&lang=js"
export * from "./ReservationForm.vue?vue&type=script&lang=js"

import "./ReservationForm.vue?vue&type=style&index=0&id=6b661fc4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b661fc4"]])

export default __exports__